// extracted by mini-css-extract-plugin
export var explainable = "_jp-a";
export var printerCard = "_jp-1";
export var printerCardConfigured = "_jp-2";
export var printerCardError = "_jp-3";
export var printerCardsContainer = "_jp-0";
export var printerIcon = "_jp-8";
export var printerIconConfigured = "_jp-5";
export var printerIconContainer = "_jp-4";
export var printerIconError = "_jp-6";
export var printerIconUnconfigured = "_jp-7";
export var workstationsTableCard = "_jp-9";